<template>
  <div class="form-group">
    <d-row v-if="!readOnly">
      <d-col cols="12" class="d-flex">
        <div :class="{ 'form-control': true, 'is-select': true }">
          <v-select
            :options="customerContacts"
            :disabled="!customerId || loadingCustomerContacts"
            v-model="contact_id"
            :searchable="false"
            :clearable="true"
            :reduce="contact => contact.id"
            :placeholder="$t('ui.selectContactPerson')"
            label="name">
            <template slot="no-options">
              {{ $t('order.noContactPeopleAssignedToClient') }}
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.name }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.name }}
              </div>
            </template>
          </v-select>
        </div>
      </d-col>
    </d-row>

    <d-row v-if="!loadingCustomerContacts">
      <p
        v-if="selectedContact"
        class="p-3">
        <em>
          {{ selectedContact.name }}<br>
          <template v-if="selectedContact.email">{{ $t('ui.eMailShort') }}: {{ selectedContact.email }}<br></template>
          <template v-if="selectedContact.phone">{{ $t('ui.phoneShort') }}: {{ selectedContact.phone }}</template>
        </em>
      </p>

      <p
        v-if="!selectedContact && readOnly"
        class="text-danger p-3">
        <em>{{ $t('ui.selectedPersonNotFound') }}&hellip;</em>
      </p>
    </d-row>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'contact-customer-contact',
  props: [
    'customerId',
    'readOnly'
  ],
  data () {
    return {
      contact_id: null,
      customerContacts: [],
      loadingCustomerContacts: false,
      loadCustomerContactsError: false,
      selectedContact: null
    }
  },
  watch: {
    customerId (newValue, oldValue) {
      if (oldValue) {
        this.contact_id = null;
      }

      this.fetchContacts();
    },
    contact_id (newValue) {
      this.$bus.$emit('ui-select-customer-contact-updated', newValue);

      if (newValue !== 0 && newValue !== null) {
        if (this.customerContacts && this.customerContacts.length) {
          let contactData = this.customerContacts.filter(contact => contact.id === newValue);

          if (contactData[0]) {
            this.selectedContact = JSON.parse(JSON.stringify(contactData[0]));
          } else {
            this.selectedContact = null;
            this.contact_id = null;
          }
        }
      } else {
        this.selectedContact = null;
      }
    },
    customerContacts () {
      if (this.customerContacts && this.customerContacts.length) {
        let contactData = this.customerContacts.filter(contact => contact.id === this.contact_id);

        if (contactData[0]) {
          this.selectedContact = JSON.parse(JSON.stringify(contactData[0]));
        } else {
          this.selectedContact = null;
          this.contact_id = null;
        }
      }
    }
  },
  mounted () {
    this.fetchContacts();
  },
  methods: {
    fetchContacts (contactIdToSet = false) {
      if (!this.customerId) {
        return;
      }

      this.loadingCustomerContacts = true;

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/customers/contacts/items',
        outputKey: 'customerContacts',
        errorKey: 'loadCustomerContactsError',
        params: {
          customer_id: this.customerId
        },
        successAction: () => {
          this.loadingCustomerContacts = false;

          Vue.nextTick(() => {
            if (contactIdToSet) {
              this.contact_id = contactIdToSet;
            }
          });
        }
      });
    },
    setContactID (newID) {
      this.contact_id = newID;
    },
    getContact () {
      let selectedContact = this.customerContacts.filter(contact => contact.id === this.contact_id);

      if (selectedContact.length) {
        return selectedContact[0];
      }

      return null;
    }
  }
}
</script>
